// Static configuration of the Google Reviews dashboard: colours, filter options, tabs.
import {
  BarChart3,
  Building2,
  LayoutDashboard,
  MessageSquareText,
  Tags,
} from "lucide-react";

// Polarity colours: blue = good, red = bad, gray = neutral (diverging pair, colour-blind safe).
export const COLORS = {
  positive: "#2a78d6",
  neutral: "#a3a19a",
  negative: "#e34948",
  accent: "#2a78d6",
  grid: "#e7e6e1",
  axis: "#898781",
};

export const RATING_COLORS = {
  5: "#2a78d6",
  4: "#86b6ef",
  3: "#c3c2b7",
  2: "#f0a19f",
  1: "#e34948",
};

export const SENTIMENTS = [
  {
    key: "pozytywna",
    label: "Pozytywne",
    single: "Pozytywna",
    field: "positive_count",
    color: COLORS.positive,
  },
  {
    key: "neutralna",
    label: "Neutralne",
    single: "Neutralna",
    field: "neutral_count",
    color: COLORS.neutral,
  },
  {
    key: "negatywna",
    label: "Negatywne",
    single: "Negatywna",
    field: "negative_count",
    color: COLORS.negative,
  },
];

export const SENTIMENT_BY_KEY = Object.fromEntries(SENTIMENTS.map((s) => [s.key, s]));

export const URGENCY_LABELS = { wysoki: "Wysoka", sredni: "Średnia", niski: "Niska" };

export const PERIOD_PRESETS = [
  { key: "3m", label: "3 mies." },
  { key: "6m", label: "6 mies." },
  { key: "12m", label: "12 mies." },
  { key: "ytd", label: "Bieżący rok" },
  { key: "last-year", label: "Poprzedni rok" },
  { key: "all", label: "Cały okres" },
  { key: "custom", label: "Własny" },
];

export const COMPARE_OPTIONS = [
  { value: "previous", label: "vs poprzedni okres" },
  { value: "yoy", label: "vs rok wcześniej" },
  { value: "none", label: "Bez porównania" },
];

export const RATING_OPTIONS = [
  { value: "", label: "Wszystkie oceny" },
  { value: "5", label: "5 ★" },
  { value: "4", label: "4 ★" },
  { value: "3", label: "3 ★" },
  { value: "2", label: "2 ★" },
  { value: "1", label: "1 ★" },
  { value: "4-5", label: "4–5 ★" },
  { value: "1-2", label: "1–2 ★ (krytyczne)" },
];

export const SORT_OPTIONS = [
  { value: "newest", label: "Najnowsze" },
  { value: "oldest", label: "Najstarsze" },
  { value: "rating_asc", label: "Najniższa ocena" },
  { value: "rating_desc", label: "Najwyższa ocena" },
  { value: "sentiment_asc", label: "Najbardziej negatywne" },
  { value: "likes", label: "Najwięcej polubień" },
];

export const GRANULARITY_OPTIONS = [
  { value: "auto", label: "Auto" },
  { value: "month", label: "Miesiące" },
  { value: "quarter", label: "Kwartały" },
  { value: "year", label: "Lata" },
];

export const TABS = [
  { key: "overview", label: "Przegląd", icon: LayoutDashboard },
  { key: "topics", label: "Tematy", icon: Tags },
  { key: "trends", label: "Trendy", icon: BarChart3 },
  { key: "team", label: "Zespół i działy", icon: Building2 },
  { key: "reviews", label: "Opinie", icon: MessageSquareText },
];

export const DEFAULT_FILTERS = {
  period: "12m",
  from: "",
  to: "",
  compare: "previous",
  department: "",
  sentiment: "",
  rating: "",
  employee: "",
  topic: "",
  theme: "",
  themeSide: "",
  strength: "",
  weakness: "",
  product: "",
  urgency: "",
  hasText: "",
  hasReply: "",
  search: "",
};

export const FILTER_KEYS = Object.keys(DEFAULT_FILTERS);

// Filters that narrow the data set beyond the period (shown as removable chips).
export const DRILL_KEYS = [
  "employee",
  "topic",
  "theme",
  "strength",
  "weakness",
  "product",
  "urgency",
  "hasText",
  "hasReply",
  "search",
];
